<template>
  <div class="update-saldo-form" :class="{ height: deposit.in || withdraw.in }">
    <icon-button icon="el-icon-arrow-left" class="back-button" v-if="deposit.in || withdraw.in" @click="reset"></icon-button>
    <icon-button icon="el-icon-close" class="close-button" @click="$emit('close')"></icon-button>

    <div class="tile--choice deposit" @click="showDepositForm" :class="classListDeposit">
      <i class="el-icon-circle-plus" />
      Deposit
    </div>
    <div class="tile--choice withdraw" @click="showWithdrawForm" :class="classListWithdraw">
      <i class="el-icon-remove" />
      Withdraw
    </div>

    <div class="deposit-form" v-if="deposit.in" :class="classListDepositForm">
      <h1>Deposit</h1>
      <dg-input type="number" v-model="formData.amount" :error="errors.amount" icon="dollar-sign" placeholder="Amount to deposit" />
      <dg-input type="text" v-model="formData.description" :error="errors.description" icon="info" placeholder="Description" />
      <el-checkbox class="margin-top" v-model="formData.charge">Charge credit card</el-checkbox>
      <el-button type="primary" icon="el-icon-upload" @click="handleClick(true)">Process</el-button>
    </div>

    <div class="withdraw-form" v-if="withdraw.in" :class="classListWithdrawForm">
      <h1>Withdraw</h1>
      <dg-input type="number" v-model="formData.amount" compact-error :error="errors.amount" icon="dollar-sign" placeholder="Amount to withdraw" />
      <dg-input type="text" v-model="formData.description" :error="errors.description" icon="info" placeholder="Description" />
      <picker
        :api="$api.stations.index"
        v-model="formData.stationId"
        :error="errors.stationId" 
        class="signup-country-picker"
        value-key="id"
        placeholder="Select station"
        icon="share-alt" />
      <el-button type="primary" icon="el-icon-upload" :loading="loading" @click="handleClick(false)">Process</el-button>
    </div>
  </div>
</template>

<script>
import Picker from '@/components/shared/CollectionPicker'

export default {
  name: 'UpdateSaldoForm',
  components: { Picker },
  data () {
    return {
      loading: false,
      deposit: {
        in: false,
        out: false,
      },
      withdraw: {
        in: false,
        out: false
      },
      formData: {
        amount: 0,
        description: null,
        charge: false,
        stationId: null
      },
      errors: {
        '': null,
        amount: null,
        description: null,
        charge: null,
        stationId: null
      }
    }
  },
  computed: {
    classListDepositForm () {
      return {
        'in': this.deposit.in,
      }
    },
    classListWithdrawForm () {
      return {
        'in': this.withdraw.in
      }
    },
    classListDeposit () {
      return { 
        'animate-in': this.deposit.in,
        'animate-out': this.deposit.out,
      }
    },
    classListWithdraw () {
      return {
        'animate-in': this.withdraw.in,
        'animate-out': this.withdraw.out,
      }
    },
    isInReverse () {
      return this.withdraw.inReverse || this.withdraw.outReverse || this.deposit.inReverse || this.deposit.outReverse
    }
  },
  watch: {
    loading (val) {
      if (val) {
        this.resetErrors()
      }
    }
  },
  methods: {
    showDepositForm () {
      if (!this.isInReverse) {
        this.deposit.in = true,
        this.withdraw.out = true
      }
    },
    showWithdrawForm () {
      if (!this.isInReverse) {
        this.withdraw.in = true,
        this.deposit.out = true
      }
    },
    reset () {
        this.deposit.in = false
        this.deposit.out = false
        this.withdraw.in = false
        this.withdraw.out = false

        this.amount = 0,
        this.description = '',
        this.charge = false,
        this.stationId = null
    },
    runErrors (errors) {
      this.errors = errors
      if (errors.hasOwnProperty('')) {
        this.$message.error(this.errors[''])
      }
    },
    resetErrors () {
      for (let key in this.errors) {
        this.errors[key] = null
      }
    },
    handleClick (deposit) {
      if (this.formData.amount === 0) {
        this.errors.amount = 'Please insert a number'
        return
      }

      if (!this.formData.description) {
        this.errors.description = 'Please include a description'
        return
      }

      this.loading = true
      const userId = this.$route.params.id

      if (deposit) {
        this.createDeposit(userId)
      } else [
        this.createPurchase(userId)
      ]
    },
    async createDeposit (userId) {
      try {
        const response = await this.$http.post(this.$api.transactions.users.deposits(userId), this.formData)
        this.$message.success('User saldo updated')
        this.$emit('created', response.data);
      } catch (e) {
        this.runErrors(e.response.data)
        this.loading = false
      }
    },
    async createPurchase (userId) {
      try {
        const response = await this.$http.post(this.$api.transactions.users.purchases(userId), this.formData)
        this.$message.success('User saldo updated')
        response.data.purchase = true
        this.$emit('created', response.data);
      } catch (e) {
        this.runErrors(e.response.data)
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  $speed: .25s;

  .height {
    animation: set-height $speed ease-in-out forwards;
    animation-delay: $speed;
  }

  @keyframes set-height
  {
    from {
      height: 250px;
    }

    to {
      height: 400px;
    }
  }

  .back-button {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 9999;
  }

  .close-button {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 9999;
  }

  .deposit-form {
    display: flex;
    flex-direction: column;
    position: absolute;
    opacity: 0;
    width: 70%;
    left: 0;
    right: 0;
    margin: 0 auto;

    .margin-top {
      margin-top: 20px;
    }

    h1 {
      color: $text-light;
      font-size: 14px;
      font-weight: 600;
    }

    button {
      margin-top: 20px;
    }
  }

  .withdraw-form {
    @extend .deposit-form;
  }

  .update-saldo-form {
    position: relative;
    height: 250px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .withdraw {
    border-left: 1px solid $border;
  }

  .in {
    animation: in $speed linear forwards;
    animation-delay: $speed;
  }

  .in-reverse {
    animation: in $speed linear reverse;
  }

  .animate-out {
    animation: x-slide-out $speed ease-in-out forwards;
  }

  .animate-in {
    animation: x-slide-in $speed ease-in-out forwards;
  }

  .animate-out-reverse {
    animation: x-slide-out $speed ease-in-out reverse;
  }

  .animate-in-reverse {
    animation: x-slide-in $speed ease-in-out reverse;
  }

  @keyframes in {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @keyframes x-slide-in {
    from {
      width: 50%;
    }

    50% {
      opacity: 1
    }

    95% {
      opacity: 0;
    }

    to {
      width: 100%;
      opacity: 0;
      cursor: default;
    }
  }

  @keyframes x-slide-out {
    from {
      width: 50%;
      opacity: 1;
    }

    50% {
      opacity: 1
    }

    95% {
      opacity: 0;
    }

    to {
      width: 0%;
      opacity: 0;
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/users/user/UpdateSaldoForm.vue